import(/* webpackMode: "eager" */ "/vercel/path0/app/vicino-a-me/ClientVicinoAMe.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EzoicAd"] */ "/vercel/path0/components/EzoicAd.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
